import PropTypes from 'prop-types'

const FeedbackCircle = ({ value, upvoteLabel, downvoteLabel }) => (
  <span
    title={value === 1 ? upvoteLabel : downvoteLabel}
    style={{
      display: 'inline-block',
      width: 18,
      height: 18,
      borderRadius: '50%',
      background: value === 1 ? '#36b37e' : '#de350b',
      border: '2px solid #e2e2e2',
      verticalAlign: 'middle'
    }}
  />
)

FeedbackCircle.propTypes = {
  value: PropTypes.number,
  upvoteLabel: PropTypes.string,
  downvoteLabel: PropTypes.string
}

export default FeedbackCircle
